import { Component, OnInit, Input, Type } from "@angular/core";
import _ from "lodash";
import { NzModalRef } from "ng-zorro-antd/modal";
import { AppService } from "@root/app.service";
import { linkListingsDoc } from "@root/config";
@Component({
  selector: "host-bind-house-picker-panel",
  templateUrl: "./bind-house-picker-panel.component.html",
  styleUrls: ["./bind-house-picker-panel.component.scss"],
})
export class BindHousePickerPanelComponent implements OnInit {
  @Input() isMultiInventory = false;
  tabIndex = 0;
  get isInternational () {
    return this.app.app.international;
  }

  get docLink () {
    return linkListingsDoc(this.isInternational);
  }
  constructor(
    private subject: NzModalRef,
    // private internationalService: InternationalService,
    private app: AppService
  ) {}

  ngOnInit() {

    if (this.isMultiInventory) {
      this.tabIndex = 1;
    } else {
      this.tabIndex = 0;
    }
  }

  onSelectHouse (data, type) {
    console.log('on select house: ', data);
    const id = data?.[0]?.value;
    this.subject.destroy({
      status: id ? 'ok' : 'cancel',
      data: { type, id }
    });
  }
}
